module.exports = __webpack_public_path__ + "img/icon-progress.d8a072f3.png";